import styles from "./index.module.scss";
import ThreeDotsIcon from "assets/icons/more-vertical.svg?react";
import { ReactNode, useId } from "react";
import { useDropdownMenu } from "hooks/useDropdownMenu";

export type DropDirection = "up" | "down";

export interface ContextMenuItem {
    key: string;
    text: string;
    onClick: (...args: any) => any;
}

export interface ContextMenuProps {
    items: ContextMenuItem[];
    dropDirection?: DropDirection;
    icon?: ReactNode;
    showBackground?: boolean;
}

export const ContextMenu = ({
    items,
    dropDirection = "down",
    icon = <ThreeDotsIcon />,
    showBackground = true
}: ContextMenuProps) => {
    const menuId = useId();
    const {
        isOpen,
        activeIndex,
        toggle,
        close,
        containerRef,
        triggerRef,
        itemRefs,
        onTriggerKeyDown,
        onMenuKeyDown
    } = useDropdownMenu(items.length);

    return (
        <div
            ref={containerRef as React.RefObject<HTMLDivElement>}
            className={`${dropDirection === "up" ? "dropup" : "dropdown"} ${
                styles["context-menu"]
            } ${showBackground ? styles["show-background"] : ""}`}
        >
            <button
                ref={triggerRef as React.RefObject<HTMLButtonElement>}
                type="button"
                aria-haspopup="menu"
                aria-expanded={isOpen}
                aria-controls={menuId}
                onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    toggle();
                }}
                onKeyDown={onTriggerKeyDown}
            >
                {icon}
            </button>
            {isOpen && (
                <div
                    id={menuId}
                    role="menu"
                    className="dropdown-menu dropdown-menu-right show"
                    onKeyDown={onMenuKeyDown}
                >
                    {items.map((item, index) => (
                        <a
                            key={item.key}
                            href="#"
                            role="menuitem"
                            title={item.key}
                            tabIndex={activeIndex === index ? 0 : -1}
                            ref={(el) => {
                                itemRefs.current[index] = el;
                            }}
                            className={`dropdown-item ${styles["context-menu-item"]}`}
                            onClick={(e) => {
                                e.preventDefault();
                                item.onClick && item.onClick();
                                close(true);
                            }}
                        >
                            {item.text}
                        </a>
                    ))}
                </div>
            )}
        </div>
    );
};
